/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { TerminiAttivoForm } from '../model/termini-attivo-form';
// @ts-ignore
import { TerminiBozzaDTO } from '../model/termini-bozza-dto';
// @ts-ignore
import { TerminiBozzaForm } from '../model/termini-bozza-form';
// @ts-ignore
import { TerminiPubblicaForm } from '../model/termini-pubblica-form';
// @ts-ignore
import { TerminiPubblicoAdminDTO } from '../model/termini-pubblico-admin-dto';
// @ts-ignore
import { TerminiVersioneDettaglioDTO } from '../model/termini-versione-dettaglio-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TerminiEPrivacyGestioneServiceInterface,
    EliminaTerminiBozzaBackofficeRequestParams,
    GetTerminiVersioneBackofficeRequestParams,
    PubblicaTerminiBozzaBackofficeRequestParams,
    SalvaTerminiBozzaBackofficeRequestParams,
    SetTerminiAttivoBackofficeRequestParams
} from './termini-e-privacy-gestione.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TerminiEPrivacyGestioneService extends BaseService implements TerminiEPrivacyGestioneServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Elimina la bozza dei termini di un pubblico (SUPERADMIN).
     * @endpoint delete /api/v1/gestione/termini/{pubblico}/bozza
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public eliminaTerminiBozzaBackoffice(requestParameters: EliminaTerminiBozzaBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public eliminaTerminiBozzaBackoffice(requestParameters: EliminaTerminiBozzaBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public eliminaTerminiBozzaBackoffice(requestParameters: EliminaTerminiBozzaBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public eliminaTerminiBozzaBackoffice(requestParameters: EliminaTerminiBozzaBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pubblico = requestParameters?.pubblico;
        if (pubblico === null || pubblico === undefined) {
            throw new Error('Required parameter pubblico was null or undefined when calling eliminaTerminiBozzaBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/termini/${this.configuration.encodeParam({name: "pubblico", value: pubblico, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bozza`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Una versione pubblicata dei termini con i testi (SUPERADMIN).
     * @endpoint get /api/v1/gestione/termini/{pubblico}/versioni/{versione}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTerminiVersioneBackoffice(requestParameters: GetTerminiVersioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminiVersioneDettaglioDTO>;
    public getTerminiVersioneBackoffice(requestParameters: GetTerminiVersioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminiVersioneDettaglioDTO>>;
    public getTerminiVersioneBackoffice(requestParameters: GetTerminiVersioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminiVersioneDettaglioDTO>>;
    public getTerminiVersioneBackoffice(requestParameters: GetTerminiVersioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pubblico = requestParameters?.pubblico;
        if (pubblico === null || pubblico === undefined) {
            throw new Error('Required parameter pubblico was null or undefined when calling getTerminiVersioneBackoffice.');
        }
        const versione = requestParameters?.versione;
        if (versione === null || versione === undefined) {
            throw new Error('Required parameter versione was null or undefined when calling getTerminiVersioneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/termini/${this.configuration.encodeParam({name: "pubblico", value: pubblico, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/versioni/${this.configuration.encodeParam({name: "versione", value: versione, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminiVersioneDettaglioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Stato dei termini per i due pubblici (SUPERADMIN).
     * Sempre due elementi (ESERCENTE, CASSIERE) con interruttore, versione corrente, bozza e storico delle versioni pubblicate (senza testi).
     * @endpoint get /api/v1/gestione/termini
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTerminiBackoffice(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<TerminiPubblicoAdminDTO>>;
    public listTerminiBackoffice(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<TerminiPubblicoAdminDTO>>>;
    public listTerminiBackoffice(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<TerminiPubblicoAdminDTO>>>;
    public listTerminiBackoffice(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/termini`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<TerminiPubblicoAdminDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Pubblica la bozza dei termini di un pubblico (SUPERADMIN).
     * Assegna il numero di versione successivo ed e\&#39; irreversibile. La prima versione di un pubblico e\&#39; sempre sostanziale. Richiede la version della bozza.
     * @endpoint post /api/v1/gestione/termini/{pubblico}/bozza/pubblica
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public pubblicaTerminiBozzaBackoffice(requestParameters: PubblicaTerminiBozzaBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminiPubblicoAdminDTO>;
    public pubblicaTerminiBozzaBackoffice(requestParameters: PubblicaTerminiBozzaBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminiPubblicoAdminDTO>>;
    public pubblicaTerminiBozzaBackoffice(requestParameters: PubblicaTerminiBozzaBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminiPubblicoAdminDTO>>;
    public pubblicaTerminiBozzaBackoffice(requestParameters: PubblicaTerminiBozzaBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pubblico = requestParameters?.pubblico;
        if (pubblico === null || pubblico === undefined) {
            throw new Error('Required parameter pubblico was null or undefined when calling pubblicaTerminiBozzaBackoffice.');
        }
        const terminiPubblicaForm = requestParameters?.terminiPubblicaForm;
        if (terminiPubblicaForm === null || terminiPubblicaForm === undefined) {
            throw new Error('Required parameter terminiPubblicaForm was null or undefined when calling pubblicaTerminiBozzaBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/termini/${this.configuration.encodeParam({name: "pubblico", value: pubblico, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bozza/pubblica`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminiPubblicoAdminDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: terminiPubblicaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea o aggiorna la bozza dei termini di un pubblico (SUPERADMIN).
     * version nulla crea la bozza; valorizzata la aggiorna con optimistic lock. L\&#39;HTML e\&#39; sanitizzato dal backend; testo_it senza testo visibile e\&#39; 400.
     * @endpoint put /api/v1/gestione/termini/{pubblico}/bozza
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public salvaTerminiBozzaBackoffice(requestParameters: SalvaTerminiBozzaBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminiBozzaDTO>;
    public salvaTerminiBozzaBackoffice(requestParameters: SalvaTerminiBozzaBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminiBozzaDTO>>;
    public salvaTerminiBozzaBackoffice(requestParameters: SalvaTerminiBozzaBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminiBozzaDTO>>;
    public salvaTerminiBozzaBackoffice(requestParameters: SalvaTerminiBozzaBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pubblico = requestParameters?.pubblico;
        if (pubblico === null || pubblico === undefined) {
            throw new Error('Required parameter pubblico was null or undefined when calling salvaTerminiBozzaBackoffice.');
        }
        const terminiBozzaForm = requestParameters?.terminiBozzaForm;
        if (terminiBozzaForm === null || terminiBozzaForm === undefined) {
            throw new Error('Required parameter terminiBozzaForm was null or undefined when calling salvaTerminiBozzaBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/termini/${this.configuration.encodeParam({name: "pubblico", value: pubblico, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/bozza`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminiBozzaDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: terminiBozzaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Attiva o disattiva la raccolta dei termini di un pubblico (SUPERADMIN).
     * Attivabile solo con almeno una versione pubblicata (422 termini_attivazione_senza_versione).
     * @endpoint put /api/v1/gestione/termini/{pubblico}/attivo
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public setTerminiAttivoBackoffice(requestParameters: SetTerminiAttivoBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TerminiPubblicoAdminDTO>;
    public setTerminiAttivoBackoffice(requestParameters: SetTerminiAttivoBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TerminiPubblicoAdminDTO>>;
    public setTerminiAttivoBackoffice(requestParameters: SetTerminiAttivoBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TerminiPubblicoAdminDTO>>;
    public setTerminiAttivoBackoffice(requestParameters: SetTerminiAttivoBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const pubblico = requestParameters?.pubblico;
        if (pubblico === null || pubblico === undefined) {
            throw new Error('Required parameter pubblico was null or undefined when calling setTerminiAttivoBackoffice.');
        }
        const terminiAttivoForm = requestParameters?.terminiAttivoForm;
        if (terminiAttivoForm === null || terminiAttivoForm === undefined) {
            throw new Error('Required parameter terminiAttivoForm was null or undefined when calling setTerminiAttivoBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/termini/${this.configuration.encodeParam({name: "pubblico", value: pubblico, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attivo`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TerminiPubblicoAdminDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: terminiAttivoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
